export default {"src":"/_next/static/media/squarespace.a9963dc8.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};